module.exports = __webpack_public_path__ + "static/media/nav-logo big.ca053d22.svg";